"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortDate = formatShortDate;
exports.formatNumber = formatNumber;
exports.formatNumberWithCommas = formatNumberWithCommas;
exports.formatPercent = formatPercent;
exports.onlyUniqueFromArray = onlyUniqueFromArray;
exports.convertRgbToHex = convertRgbToHex;

// Format any date
function formatShortDate(dateString) {
  return dateString && new Date(dateString).toLocaleDateString(undefined, {
    month: 'numeric',
    year: '2-digit'
  });
} // Format any number as decimal


function formatNumber(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return number !== null && number !== undefined ? parseFloat(number).toFixed(decimals) : '-';
} // Format any number with commas (no d.p)


function formatNumberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
} // Format any number as a percent


function formatPercent(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var showPercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return number !== null && number !== undefined && number !== 0 ? parseFloat(number * 100).toFixed(decimals) + (showPercent ? "%" : '') : '-';
} // Get distinct values from a list


function onlyUniqueFromArray(array) {
  return array.filter(function (item, index, self) {
    return self.indexOf(item) === index;
  });
} // Change an RGB to hex


function convertRgbToHex(rgb) {
  if (rgb.search("rgb") === -1) {
    return rgb;
  } else if (rgb === 'rgba(0, 0, 0, 0)') {
    return 'transparent';
  } else {
    var hex = function hex(x) {
      return ("0" + parseInt(x).toString(16)).slice(-2);
    };

    rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
    return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/dist/util/functions.js
// module id = 221
// module chunks = 0